import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';

// Services
import {CatalogService} from './catalog-service';

// Interfaces
import {AppState} from '../../../shared/state/interfaces/app-state';

// State
import {
    SELECT_RENDER_MODE,
    SELECT_PRODUCT_CATEGORY
} from '../state/catalog-actions';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:AppCatalogService'));

@Injectable()
export class AppCatalogService {

    public globals: any;
    
    constructor (
        private _store: Store<AppState>,
        private _catalogService: CatalogService,
    ) {
        // 'Construct catalog service' );

        this.globals = this._catalogService.getGlobals();
    }

    public getCatalogDataAsync = this._catalogService.getCatalogDataAsync.bind( this._catalogService );

    
    public init (AppService) {
        // 'Initialise app catalog service' );
        this._catalogService.init( AppService );
    }

    
    public selectCategory (event) {

        if (typeof event === 'string') {
            event = {
                category: this._catalogService.getProductCategoryById( event )
            };
            debugOff( 'Update event from string to ProductCategory' );
        }

        // 'Select catalog category:', [event.category] );

        this._store.dispatch({
            type: SELECT_PRODUCT_CATEGORY,
            payload: event.category
        });
    }

    
    public selectRenderMode (renderMode) {
        debugOff( 'Select catalog render mode:', renderMode );

        this._store.dispatch({
            type: SELECT_RENDER_MODE,
            payload: renderMode
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/services/app-catalog-service.ts